<!-- eslint-disable vue/multi-word-component-names -->
<!-- no-mutating-props: form/ui/consent are reactive MODEL objects owned by the
     core QuestionGateBlock; presentational SFCs cannot hold state, so two-way
     binding mutates the passed models by design. -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  question: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  };
  gate: {
    cta?: string;
    loading?: string;
    description?: string;
    sub_title?: string;
    namePlaceholder?: string;
    emailPlaceholder?: string;
    nameError?: string;
    emailError?: string;
    usePhone?: boolean;
    useEmail?: boolean;
    consent_checkbox?: { text: string; required?: boolean };
  };
  quiz: { skip?: boolean; skip_cta?: string };
  form: { name: string; email: string; phone?: string };
  ui: { answerIndex: number };
  consent: { checked: boolean };
  fetching: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <form class="tpl-slider__form" @submit.prevent="$emit('submit')">
    <div class="tpl-slider__question-row">
      <span class="tpl-slider__question-label">{{ question.title }}</span>
      <span class="tpl-slider__value-badge">
        {{ String((question.answers[ui.answerIndex] || question.answers[0])[1]) }}
      </span>
    </div>

    <input
      type="range"
      class="tpl-slider__range"
      min="0"
      :max="question.answers.length - 1"
      step="1"
      v-model.number="ui.answerIndex"
      :aria-label="question.title"
    />

    <label class="tpl-slider__field-label">{{ gate.namePlaceholder }}</label>
    <input
      type="text"
      name="name"
      class="tpl-slider__input"
      :placeholder="gate.namePlaceholder"
      :title="gate.nameError"
      required
      minlength="3"
      v-model="form.name"
    />

    <label v-if="gate.useEmail" class="tpl-slider__field-label">{{ gate.emailPlaceholder }}</label>
    <input
      v-if="gate.useEmail"
      type="email"
      name="email"
      class="tpl-slider__input"
      :placeholder="gate.emailPlaceholder"
      :title="gate.emailError"
      required
      pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
      v-model="form.email"
    />

    <p v-if="gate.description" class="tpl-slider__note">{{ gate.description }}</p>

    <label v-if="gate.consent_checkbox" class="tpl-slider__consent">
      <input
        type="checkbox"
        name="consent"
        :required="gate.consent_checkbox.required !== false"
        v-model="consent.checked"
      />
      <span>{{ gate.consent_checkbox.text }}</span>
    </label>

    <button type="submit" class="tpl-slider__cta" :disabled="fetching">
      <span v-if="!fetching">{{ gate.cta }}</span>
      <span v-else>{{ gate.loading || '...' }}</span>
    </button>

    <p v-if="gate.sub_title" class="tpl-slider__secure">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 1 1 6 0v3H9z"/></svg>
      {{ gate.sub_title }}
    </p>
  </form>
</template>
